import { FC, ReactNode } from 'react'

import { Button, Card, CardContent, CardHeader, CardTitle, EmptyState, Skeleton } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

type DashboardWidgetCardProps = {
  title?: string
  children: ReactNode
}

export const DashboardWidgetCard: FC<DashboardWidgetCardProps> = ({ title, children }) => (
  <Card>
    {title ? (
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
    ) : null}
    <CardContent>{children}</CardContent>
  </Card>
)

type DashboardWidgetCardSkeletonProps = {
  // Must match whether the loaded widget has a title, or the card shifts when data arrives.
  withTitle?: boolean
  children?: ReactNode
}

export const DashboardWidgetCardSkeleton: FC<DashboardWidgetCardSkeletonProps> = ({ withTitle = false, children }) => (
  <Card>
    {withTitle ? (
      <CardHeader>
        <Skeleton variant="content" />
      </CardHeader>
    ) : null}
    <CardContent>{children ?? <Skeleton variant="card" fullWidth />}</CardContent>
  </Card>
)

type DashboardWidgetErrorProps = {
  onRetry: () => void
}

export const DashboardWidgetError: FC<DashboardWidgetErrorProps> = ({ onRetry }) => {
  const { translate } = useLocalisation()

  return (
    <EmptyState
      title={translate('dashboard.widget.error')}
      description={null}
      actions={
        <Button variant="ghost" size="sm" onClick={onRetry}>
          {translate('dashboard.widget.retry')}
        </Button>
      }
    />
  )
}
